function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
//Limitless imports
import SlideImage from "../slide-image/SlideImage";
import SlideBody from "../slide-body/SlideBody";
import SlideTitle from "../slide-title/SlideTitle";
import SlideCloseIcon from "../slide-close-icon/SlideCloseIcon";
const ImageTitleBody = ({
  classes,
  slide,
  shouldAnimate,
  ...rest
}) => {
  const {
    imgSrc,
    headline,
    headlineColor
  } = slide;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.imageTitleBodyContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.imageContainer
  }, /*#__PURE__*/React.createElement(SlideImage, {
    imgSrc: imgSrc,
    primaryColour: "unset",
    shouldAnimate: shouldAnimate
  }), /*#__PURE__*/React.createElement(SlideCloseIcon, _extends({
    slide: slide
  }, rest))), /*#__PURE__*/React.createElement("div", {
    className: classes.textContainer
  }, /*#__PURE__*/React.createElement(SlideTitle, {
    slide: slide,
    gutterBottom: false,
    style: {
      backgroundColor: "unset"
    }
  }), /*#__PURE__*/React.createElement(SlideBody, {
    headline: headline,
    shouldAnimate: shouldAnimate,
    color: headlineColor
  })));
};
const styles = {
  imageTitleBodyContainer: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    justifyContent: "center"
  },
  imageContainer: {
    position: "relative",
    margin: "0px auto",
    overflowY: "hidden",
    width: 320,
    height: 290 // this was added to stop an image load flicker
  },
  "@media screen and (min-width: 450px)": {
    imageContainer: {
      borderTopLeftRadius: 12,
      borderTopRightRadius: 12,
      margin: "0px auto",
      overflowY: "hidden"
    }
  },
  textContainer: {
    display: "flex",
    justifyContent: "space-around",
    flexDirection: "column",
    flex: 1,
    maxHeight: 150
  }
};
export default withStyles(styles)(ImageTitleBody);
ImageTitleBody.propTypes = {
  classes: PropTypes.object.isRequired,
  shouldAnimate: PropTypes.bool,
  slide: PropTypes.object.isRequired
};